import { ChangeEvent, FC, useState } from 'react';

import MandatoryField from '../MandatoryField';
import InputError from '../InputError';

type InputDateProps = {
  id: string;
  value: string;
  label?: string;
  onChange: (
    event: ChangeEvent<HTMLInputElement> // eslint-disable-line
  ) => void;
  minDate?: string;
  errorMessageKey?: string;
  required?: boolean;
  lgSize?: boolean;
  disabled?: boolean;
};

const MAX_DATE = '2100-01-01';
const DEFAULT_ERROR_MESSAGE_KEY = 'InvalidDate';

const InputDate: FC<InputDateProps> = ({
  id,
  value,
  label,
  onChange,
  minDate,
  errorMessageKey = DEFAULT_ERROR_MESSAGE_KEY,
  required = false,
  lgSize = true,
  disabled = false,
}) => {
  const [hasInvalidDate, setHasInvalidDate] = useState(false);

  const handleChangeInput = (event: ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;

    if (minDate && value < minDate) {
      setHasInvalidDate(true);
    } else {
      setHasInvalidDate(false);
    }

    onChange(event);
  };

  return (
    <div className="form-group">
      {label && (
        <label className="form-label d-flex " htmlFor={id}>
          {label}{' '}
          {required && (
            <span className="ml-1">
              <MandatoryField />
            </span>
          )}
        </label>
      )}

      <div className="form-control-wrap">
        <input
          id="capital-decrease-date"
          type="date"
          className={`form-control ${lgSize ? 'form-control-lg' : ''}`}
          value={value}
          onChange={handleChangeInput}
          required
          max={MAX_DATE}
          min={minDate}
          disabled={disabled}
        />
      </div>

      {hasInvalidDate && (
        <div className="mt-1">
          <InputError errorMessage={errorMessageKey} />
        </div>
      )}
    </div>
  );
};

export default InputDate;
